import { render } from "./informeMensualGestion.vue?vue&type=template&id=6673620f&scoped=true"
import script from "./informeMensualGestion.vue?vue&type=script&lang=js"
export * from "./informeMensualGestion.vue?vue&type=script&lang=js"

import "./informeMensualGestion.vue?vue&type=style&index=0&id=6673620f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6673620f"]])

export default __exports__